import React from "react";
import ReactDOM from "react-dom";
import withAppProviders from "./withAppProviders";
import PubSub from "./eventBus";
import { CartButton } from "./cart";

window.vinoPubSub = PubSub;
const CartApp = withAppProviders(CartButton)();

document.addEventListener("DOMContentLoaded", function () {
	var element = document.getElementById("wp-vino-drawer");
	if (typeof element !== "undefined" && element !== null) {
		ReactDOM.render(<CartApp />, document.getElementById("wp-vino-drawer"));
	}
});
